var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipse101(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 549,
    height: 366,
    viewBox: "0 0 549 366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.525 30.211C546.545 42.3686 546.72 58.2742 540.101 77.2031C533.488 96.1172 520.239 117.559 501.257 140.189C463.312 185.425 403.005 234.758 329.29 277.317C255.575 319.876 182.697 347.438 124.55 357.681C95.4604 362.805 70.2672 363.558 50.5803 359.828C30.878 356.096 17.191 347.991 10.1718 335.834C3.15269 323.676 2.97727 307.77 9.5961 288.841C16.2097 269.927 29.4578 248.486 48.4407 225.855C86.3852 180.62 146.693 131.287 220.408 88.7276C294.122 46.1683 367 18.607 425.147 8.36373C454.237 3.23923 479.43 2.48696 499.117 6.21645C518.819 9.94883 532.506 18.0535 539.525 30.211Z",
    stroke: "url(#paint0_linear_2201_2784)",
    strokeWidth: 7.58392
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2201_2784",
    x1: 350.959,
    y1: 275.91,
    x2: 283.293,
    y2: 109.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8BA3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse101);
export default __webpack_public_path__ + "static/media/Ellipse 101.0c7589de64174d757bf4a87123a43b4e.svg";
export { ForwardRef as ReactComponent };